/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretRight = createReactComponent("caret-right", "IconCaretRight", [
  ["path", { d: "M10 18l6 -6l-6 -6v12", key: "svg-0" }]
]);

export { IconCaretRight as default };
//# sourceMappingURL=IconCaretRight.js.map
